import React from 'react';
import { SendOutlined, InfoCircleOutlined } from '@ant-design/icons';
import {
    Input,
    message,
    List,
    Typography, 
    Space,
    Image,
    Button,
} from 'antd';
import './LZHXProductSearchPage.css';
import axios from 'axios';
import qs from 'qs';

//const baseUrl = "http://localhost:8080/laizeAdmin";
// const baseUrl = "https://47.100.83.180/api";
const baseUrl = "https://www.laizekeji.cn/api";
const { Title } = Typography;

class LZHXProductSearchPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = { isLoading: false, dataList: [] };
        this.searchOrder = this.searchOrder.bind(this);
        this.jumpToShopDetail = this.jumpToShopDetail.bind(this);
        this.sendMsgToUser = this.sendMsgToUser.bind(this);
    }

    componentDidMount() {

    }

    searchOrder (context) {
        console.log(context);
        if (context === "") {
            console.log("请输入搜索内容");
            message.info('请输入搜索内容', 1);
            return;
        }
        
        this.requestList(context, 1, 99999);
    }

    requestList(context, page, size) {
        const _this=this;
        this.setState({
            isLoading: true,
        });

        let params = {
            keyword: context,
            page: page,
            size: size,
        };

        axios.post(baseUrl + '/v1/goods/search', qs.stringify(params))
        .then(function (res) {
            _this.setState({
                isLoading: false,
                dataList: res.data.data || [],
            });
        })
        .catch(function (error){
            console.log(error);
            _this.setState({
                isLoading: false,
                dataList: [],
            });
        });
    }

    jumpToShopDetail(pid) {
        const w=window.open('about:blank');
        w.location.href="http://www.laizekeji.cn/laizePc/shopDetail.html?pid="+pid;
    }

    sendMsgToUser(item) {
        var standardData = {
            easemob: {
                kefu: {
                    articles: [{
                        lztype:"productDetail",
                        title: item.title || "商品标题",
                        url: "http://www.laizekeji.cn/laizePc/shopDetail.html?pid="+(item.pid||""),
                        picurl: item.banner.replace("http://47.92.85.113", "https://www.laizekeji.cn"),
                        thumbUrl: encodeURI(item.banner.replace("http://47.92.85.113", "https://www.laizekeji.cn")),
                        jump: {
                            des: "productDetail",
                            params: {
                                goodsId: item.pid,
                            },
                        },
                        goodsId: (item.pid+"") || "",
                        price: "¥" + item.price,
                        desc: "",
                        img_url: item.banner.replace("http://47.92.85.113", "https://www.laizekeji.cn"),
                        item_url: "http://www.laizekeji.cn/laizePc/shopDetail.html?pid="+(item.pid||""),
                    }]
                }
            }
        };
        
        window.parent.postMessage(standardData, '*');
    }

    render() {
        return (
            <>
                <Input.Search
                    size={"middle"}
                    placeholder={"请输入商品名称"}
                    allowClear={true}
                    onSearch={this.searchOrder}
                    enterButton={true}
                />
                <br />
                <br />
                <List
                    itemLayout="horizontal"
                    size="small"
                    pagination={{
                    onChange: page => {
                        // this.requestList(this.state.searchWords, page, 5);
                    },
                    pageSize: 4,
                    }}
                    dataSource={this.state.dataList}
                    renderItem={item => (
                        <List.Item key={item.pid} actions={[
                            <IconText icon={SendOutlined} text="发送给用户" key="list-vertical-star-o" click={()=>this.sendMsgToUser(item)} />,
                            <IconText icon={InfoCircleOutlined} text="查看详情" key="list-vertical-like-o" click={()=>this.jumpToShopDetail(item.pid)} />,
                          ]}>
                            <Image width={100} height={100} src={item.banner.replace("http://47.92.85.113", "https://www.laizekeji.cn")} />
                            <div>
                                <Title level={5} style={{width:100}} ellipsis={{ rows: 2, expandable: true, symbol: 'more' }}> {item.title} </Title>
                                <div> 价格：{item.price} </div>
                                <div> 代理价：{item.agentPrice} </div>
                                <br/>
                            </div>
                        </List.Item>
                    )}
                />
            </>
        );
    }
}

const IconText = ({ icon, text , click}) => (
  <Space>
    <Button onClick={click} type="primary" size="small" shape="round" icon={React.createElement(icon)}>{text}</Button>
  </Space>
);

export default LZHXProductSearchPage;